import { Phone, MessageCircle, FileText, MapPin } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { getBusinessConfig } from "@/lib/site-config";
import { trackEvent, getWhatsAppUrl } from "@/lib/tracking";
import { buildDirectionsUrl, trackDirectionsClick } from "@/lib/location-links";

const itemBase =
  "flex min-h-[60px] flex-col items-center justify-center gap-1 px-1 py-2.5 text-[10.5px] font-bold tracking-[0.06em] uppercase transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring";

export function MobileBottomBar() {
  const biz = getBusinessConfig();
  const whatsappUrl = getWhatsAppUrl() || biz.whatsappUrl;

  return (
    <nav
      aria-label="Quick contact"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-border bg-card/98 backdrop-blur-xl safe-area-pb shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.18)]"
    >
      <div className="grid grid-cols-4 divide-x divide-border/60">
        <a
          href={biz.phoneHref}
          onClick={() => trackEvent("call_click", { location: "mobile_bar" })}
          className={`${itemBase} bg-primary text-primary-foreground active:bg-primary/90`}
          aria-label={`Call Woodseer Autos on ${biz.phone}`}
        >
          <Phone className="h-5 w-5" aria-hidden="true" />
          Call
        </a>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent("whatsapp_click", { location: "mobile_bar" })}
          className={`${itemBase} text-[#1da851] active:bg-[#25D366]/10`}
          aria-label="Message Woodseer Autos on WhatsApp"
        >
          <MessageCircle className="h-5 w-5" aria-hidden="true" />
          WhatsApp
        </a>
        <Link
          to="/book"
          onClick={() => trackEvent("service_cta_click", { location: "mobile_bar" })}
          className={`${itemBase} text-foreground active:bg-secondary/70`}
          aria-label="Request a booking"
        >
          <FileText className="h-5 w-5" aria-hidden="true" />
          Enquire
        </Link>
        <a
          href={buildDirectionsUrl("entrance")}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackDirectionsClick({ source: "mobile_bar", kind: "entrance", action: "find_us_tap" })}
          className={`${itemBase} text-foreground/80 active:bg-secondary/70`}
          aria-label="Get directions to the workshop yard"
        >
          <MapPin className="h-5 w-5" aria-hidden="true" />
          Find Us
        </a>
      </div>
    </nav>
  );
}
